<template>
  <el-card style="margin-top: 100px;">


    <el-row>
      <div style="text-align: center">
        <br />
        <br />
        <br />
        <br />

        <i class="el-icon-success" style="color: #13a07b; font-size: 120px" />
        <br />
        <br />
        <br />
        <el-link class="gradient-button1" style=" font-size: 30px" type="primary" @click="backtoStart">{{
          $t("CONTACT_ADDRESS_UPDATED") }}</el-link>
        <br />

        <p> {{ $t('TITLE_LIST_3') }}</p>

      </div>


      <el-button v-show="isAppFlag" class="gradient-button1" type="primary" @click="backtoMain()"> {{ $t('back') }}
      </el-button>
    </el-row>
  </el-card>
</template>

<script>

export default {
  data() {
    return {
      loading: false,
      isAppFlag: false
    };
  },
  mounted() {
    this.loading = false;
    this.isAppFlag = this.isApp();
    window.JsApi.Notification.sendEvent('close-identity-begin-page');
    window.JsApi.Page.setTitleVisible(false);
  },


  methods: {
    isApp() {
      return window.GovAppBridge || window.webkit;
    },
    async backtoStart() {
      this.$router.push("/start")
    },

    backtoMain() {
      window.JsApi.Page.closePrePage();
      window.JsApi.Page.closePage();
    }
  },
};
</script>


